import React from "react"
import "./NodePalette.css"

const NodePalette = () => {
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData("application/reactflow", nodeType)
    event.dataTransfer.effectAllowed = "move"
  }

  // Return an empty fragment instead of all the node options
  return <></>
}

export default NodePalette
